module.exports = __webpack_public_path__ + "img/DE00856.0ea48a86.png";